import { useEffect } from 'react'

const SITE_URL = 'https://rithmo.ai'
const DEFAULT_TITLE = 'Rithmo — AI Meeting Host'
const DEFAULT_DESCRIPTION =
  'Rithmo is an AI meeting host that enforces agendas, tracks talk equity, captures decisions and action items, and delivers structured outputs — so your meetings actually accomplish things.'

function setMeta(property, content, attr = 'name') {
  let el = document.querySelector(`meta[${attr}="${property}"]`)
  if (el) el.setAttribute('content', content)
}

function setOrCreateMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.name = name
    document.head.appendChild(el)
  }
  el.content = content
}

/**
 * Sets page-specific <title>, meta description, OG, and canonical on mount.
 * Keeps Google's JS renderer happy when it processes each route.
 */
export function usePageMeta({ title, description } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? title.includes('Rithmo')
        ? title
        : `${title} | Rithmo`
      : DEFAULT_TITLE
    const desc = description || DEFAULT_DESCRIPTION

    document.title = fullTitle

    setOrCreateMeta('description', desc)
    setMeta('og:title', fullTitle, 'property')
    setMeta('og:description', desc, 'property')
    setMeta('og:url', window.location.href, 'property')
    setMeta('twitter:title', fullTitle)
    setMeta('twitter:description', desc)

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = `${SITE_URL}${window.location.pathname}`
  }, [title, description])
}
